import React, { useState, useEffect, useRef } from "react";
import {
  Home, Package, FileText, Users, ShoppingCart, ShoppingBag,
  BarChart2, FileSpreadsheet, Bell, ChevronDown, LogOut, Settings
} from "lucide-react";
import { auth, database } from "../firebase";
import { ref, onValue } from "firebase/database";
import { Link, useNavigate, useLocation, Outlet } from "react-router-dom";
import MainLayout from "./MainLayout";

const PRIMARY = "#2563eb";
const SECONDARY = "#fff";
const CONTENT_BG = "#F3F4F6";
const SUPER_ADMIN_EMAIL = 'saalim@gmail.com';

export const menuData = [
  {
    key: "items", icon: <Package size={14} />, label: "ITEMS", submenu: [
      { label: "Products [Add/Edit]", path: "/dashboard/product" },
      { label: "Product Group", path: "/dashboard/group-table" },
      { label: "Product Category", path: "/dashboard/category-table" },
      { label: "Brand", path: "/dashboard/brand-table" },
      { label: "Unit", path: "/dashboard/unit-table" },
      { label: "Design No", path: "/dashboard/design-no" },
      { label: "Daily Expense", path: "/dashboard/daily-Expense" },
      {
        label: "Tax",
        path: "/dashboard/tax",
        subItems: [{ label: "GST Tax", path: "/dashboard/gst-tax" }]
      },
    ]
  },
  {
    key: "accounts", icon: <FileText size={14} />, label: "ACCOUNTS", submenu: [
      { label: "Payment Modes", path: "/dashboard/payment-modes" },
      { label: "Payables", path: "/dashboard/payables" },
      { label: "Receivables", path: "/dashboard/receivables" },
    ]
  },
  {
    key: "contacts", icon: <Users size={14} />, label: "CONTACTS", submenu: [
      { label: "Suppliers", path: "/dashboard/suppliers" },
      { label: "Customers", path: "/dashboard/customers" },
      { label: "Partners", path: "/dashboard/partners" }
    ]
  },
  {
    key: "purchase", icon: <ShoppingCart size={14} />, label: "PURCHASE", submenu: [
      { label: "Opening Stock Entry", path: "/dashboard/stocks" },
      { label: "Purchase Invoice", path: "/dashboard/purchase-invoice" },
      { label: "Purchase Return", path: "/dashboard/purchase-return" },
      { label: "Barcode Generator", path: "/dashboard/barcode-generator" }
    ]
  },
  {
    key: "sales", icon: <ShoppingBag size={14} />, label: "SALES", submenu: [
      { label: "Sales List", path: "/dashboard/salesform" },
      { label: "Sales Return", path: "/dashboard/salesReturn" }
    ]
  },
  {
    key: "reports", icon: <BarChart2 size={14} />, label: "REPORTS", submenu: [
      { label: "Purchase Report", path: "/dashboard/purchase-report" },
      { label: "Purchase Return Report", path: "/dashboard/purchase-return-report" },
      { label: "Sales Report", path: "/dashboard/sales-report" },
      { label: "Sales Return Report", path: "/dashboard/sales-return-report" },
      {
        label: "Stock Report",
        path: "/dashboard/stock-report",
        subItems: [
          { label: "Godown Stock Report", path: "/dashboard/stock-report/godown" },
          // { label: "Store Stock Report", path: "/dashboard/stock-report/store" },
          // { label: "Stock Summary", path: "/dashboard/stock-report/summary" },
        ]
      },
      { label: "Product Profit Report", path: "/dashboard/product-profit-report" },
      {
        label: "Accounts",
        path: "/dashboard/accounts-report",
        subItems: [
          { label: "Supplier Payment Entry Report", path: "/dashboard/accounts-report/supplier-payment" },
          { label: "Customer Receipt Report", path: "/dashboard/accounts-report/customer-receipt" },
          { label: "Customer outstanding report", path: "/dashboard/accounts-report/customer-outstanding" },
          { label: "Purchase Outstanding", path: "/dashboard/accounts-report/purchase-outstanding" },
        ]
      },
      { label: "Daily Expense Report", path: "/dashboard/daily-expense-report" },
      { label: "Barcode List Report", path: "/dashboard/bacode-list-report" },
      {
        label: "Sales And Revenue Report", path: "/dashboard/sales-revenue-report", subItems: [
          { label: "Top Selling Products", path: "/dashboard/sales-revenue-report/top-selling" },
          { label: "Non Selling Products", path: "/dashboard/sales-revenue-report/non-selling" },
            { label: "Bottom Selling Products", path: "/dashboard/sales-revenue-report/Bottom-selling" },
        ]
      },
      { label: "Best Rate Finder", path: "/dashboard/best-rate-finder" },
    ]
  },
  {
    key: "gstReports", icon: <FileSpreadsheet size={14} />, label: "GST REPORTS", submenu: [
      {
        label: "Purchase Annexure 1A",
        path: "/dashboard/purchase-annexure-1a",
        subItems: [
          { label: "Supplierwise (GSTIN)_1A", path: "/dashboard/purchase-annexure-1a/supplierwise" },
          { label: "Productwise (HSN)_1A", path: "/dashboard/purchase-annexure-1a/productwise" }
        ]
      },
      {
        label: "Purchase Return Annexure 2A",
        path: "/dashboard/purchase-return-annexure-2a",
        subItems: [
          { label: "SupplierwiseReturn (GSTIN)_1A", path: "/dashboard/purchase-return-annexure-2a/supplierwiseReturn" },
          { label: "ProductwiseReturn (HSN)_1A", path: "/dashboard/purchase-return-annexure-2a/productwiseReturn" }
        ]
      },
      {
        label: "Sales Annexure_1A",
        path: "/dashboard/sales-annexure-1a",
        subItems: [
          { label: "Customerwise (GSTIN)_1A", path: "/dashboard/sales-annexure-1a/customerwise" },
          { label: "Productwise (HSN)_1A", path: "/dashboard/sales-annexure-1a/productwise" }
        ]
      },
      {
        label: "Sales Return Annexure_2A",
        path: "/dashboard/sales-return-annexure-2a",
        subItems: [
          { label: "Customerwise Return (GSTIN)_1A", path: "/dashboard/sales-return-annexure-2a/customerwiseReturn" },
          { label: "Productwise Return (HSN)_1A", path: "/dashboard/sales-return-annexure-2a/productwiseReturn" }
        ]
      }
    ]
  },
  {
    key: "configure",
    icon: <Settings size={14} />,
    label: "CONFIGURE",
    submenu: [
      {
        label: "Roles & Rights",
        path: "/dashboard/rolesRights",
        subItems: [
          { label: "Employee Role", path: "/dashboard/rolesRights/employeerole" },
          { label: "Manage Employee Role & Branches", path: "/dashboard/rolesRights/manage-employee" },
          { label: "Employee Right", path: "/dashboard/rolesRights/employeeright" },
          //  { label: "QRLoginSystem ", path: "/dashboard/rolesRights/qrloginsystem " },
        ]
      },
    ]
  }
];

function useOutsideAlerter(ref, handler) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) handler();
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [ref, handler]);
}

export default function Dashboard() {
  const [openMenus, setOpenMenus] = useState([]);
  const [showAdminMenu, setShowAdminMenu] = useState(false);
  const [branchName, setBranchName] = useState("Admin");
  const [allowedMenus, setAllowedMenus] = useState({});
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isBranch, setIsBranch] = useState(false);
  const [loadingUser, setLoadingUser] = useState(true);
  const [totalPaidLast30Days, setTotalPaidLast30Days] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const menuBarRef = useRef(null);

  useOutsideAlerter(menuBarRef, () => setOpenMenus([]));

  const getCurrentActiveMenu = () => {
    const currentPath = location.pathname;
    for (const menu of menuData) {
      for (const submenu of menu.submenu || []) {
        if (currentPath === submenu.path) {
          return menu.label;
        }
        if (submenu.subItems) {
          for (const subitem of submenu.subItems) {
            if (currentPath === subitem.path || currentPath.startsWith(subitem.path + '/')) {
              return menu.label;
            }
          }
        }
      }
    }
    return null;
  };
  const activeMenu = getCurrentActiveMenu();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        const emailKey = user.email.replace(/\./g, '_');
        setIsSuperAdmin(user.email === SUPER_ADMIN_EMAIL);
        const profileRef = ref(database, `users/${emailKey}/profile`);
        onValue(profileRef, (snapshot) => {
          const profileData = snapshot.val();
          setIsBranch(profileData?.isBranch || false);
        }, { onlyOnce: true });
        const branchProfilesRef = ref(database, `users/${emailKey}/branchProfiles`);
        onValue(branchProfilesRef, (snapshot) => {
          const data = snapshot.val();
          if (data) setBranchName(Object.values(data)[0]?.branchName || "Admin");
        });
        if (user.email !== SUPER_ADMIN_EMAIL && !isBranch) {
          const rightsRef = ref(database, `employeeRights/${emailKey}`);
          onValue(rightsRef, (snapshot) => {
            const data = snapshot.val();
            setAllowedMenus(data?.allowedMenus || {});
          });
        } else {
          setAllowedMenus({});
        }
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        const transactionsRef = ref(database, `users/${emailKey}/transactions`);
        onValue(transactionsRef, (snapshot) => {
          const data = snapshot.val();
          let totalPaid = 0;
          if (data) {
            Object.values(data).forEach((transaction) => {
              const paymentDate = new Date(transaction.timestamp);
              if (paymentDate >= thirtyDaysAgo && transaction.paymentAmount) {
                totalPaid += Number(transaction.paymentAmount) || 0;
              }
            });
          }
          setTotalPaidLast30Days(totalPaid.toFixed(2));
        });
      } else {
        setIsSuperAdmin(false);
        setIsBranch(false);
        setAllowedMenus({});
        setTotalPaidLast30Days(0);
        navigate("/login", { replace: true });
      }
      setLoadingUser(false);
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      setOpenMenus([]);
      setShowAdminMenu(false);
      setAllowedMenus({});
      setTotalPaidLast30Days(0);
      setBranchName("Admin");
      setIsSuperAdmin(false);
      setIsBranch(false);
      await auth.signOut();
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Logout failed:", error);
      navigate("/login", { replace: true });
    }
  };

  function isMenuOpen(pathArr) {
    return (
      openMenus.length >= pathArr.length &&
      openMenus.slice(0, pathArr.length).join(">") === pathArr.join(">")
    );
  }

  function toggleMenu(pathArr) {
    if (isMenuOpen(pathArr)) {
      setOpenMenus(openMenus.slice(0, pathArr.length - 1));
    } else {
      setOpenMenus(pathArr);
    }
  }

  function forceMenuOpen(pathArr) {
    setOpenMenus(pathArr);
  }

  function filterMenuItems(items) {
    if (isSuperAdmin || isBranch) {
      return items; // SuperAdmin and branch users see all menu items
    }

    return items.reduce((filtered, item) => {
      if (allowedMenus[item.label]) {
        const filteredSubmenu = item.submenu.filter(sub => 
          allowedMenus[item.label].includes(sub.path) || 
          (sub.subItems && sub.subItems.some(subItem => allowedMenus[item.label].includes(subItem.path)))
        ).map(sub => ({
          ...sub,
          subItems: sub.subItems 
            ? sub.subItems.filter(subItem => allowedMenus[item.label].includes(subItem.path))
            : undefined
        }));
        
        if (filteredSubmenu.length > 0) {
          return [...filtered, { ...item, submenu: filteredSubmenu }];
        }
      }
      return filtered;
    }, []);
  }

  const filteredMenuData = filterMenuItems(menuData);

  function renderMenuItems(items, parentPath = [], level = 1) {
    const fontSize = level === 1 ? "13px" : "12px";
    return items.map((item, idx) => {
      const hasSub = !!item.subItems;
      const thisPath = [...parentPath, item.label];
      const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
      const shouldHideLabel = isActive && !hasSub;

       return (
        <div
          key={`${item.label}-${idx}`}
          style={{ position: "relative" }}
        >
          <Link
            to={item.path}
            style={{
              color: isActive ? SECONDARY : PRIMARY,
              background: isActive ? PRIMARY : "transparent",
              textDecoration: "none",
              display: "block",
              fontWeight: isActive ? 700 : 500,
              fontSize: fontSize,
            }}
            onClick={(e) => {
              if (hasSub) {
                e.preventDefault();
                toggleMenu(thisPath);
              } else {
                setOpenMenus([]);
              }
            }}
          >
            <div
              className="menu-item"
              style={{
                padding: level === 1 ? "10px 16px" : "8px 14px",
                borderRadius: 4,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                transition: "all 0.2s ease",
                background: isActive ? PRIMARY : "transparent",
                color: isActive ? SECONDARY : PRIMARY,
              }}
            >
              <span
                style={{
                  width: "6px",
                  height: "6px",
                  borderRadius: "50%",
                  background: isActive ? SECONDARY : PRIMARY,
                  opacity: 0.6,
                  marginRight: 10,
                }}
              />
              <span style={{
                flex: 1,
                whiteSpace: "normal",
                lineHeight: "1.2",
                wordBreak: "break-word",
                maxWidth: "120px"
              }}>
                {item.label}
              </span>
              {hasSub && (
                <ChevronDown
                  size={12}
                  style={{
                    marginLeft: "auto",
                    transform: isMenuOpen(thisPath) ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.18s",
                    flexShrink: 0,
                  }}
                />
              )}
            </div>
          </Link>
          {hasSub && isMenuOpen(thisPath) && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: "100%",
                background: SECONDARY,
                color: PRIMARY,
                minWidth: "160px",
                maxWidth: "180px",
                boxShadow: `0 4px 20px ${PRIMARY}15`,
                zIndex: 400 + thisPath.length,
                padding: "8px 0",
                marginLeft: "4px",
                borderRadius: 6,
                border: `1px solid ${PRIMARY}12`,
                maxHeight: "80vh",
              }}
            >
              {renderMenuItems(item.subItems, thisPath, level + 1)}
            </div>
          )}
        </div>
      );
    });
  }

  const isDashboardHome = location.pathname === "/dashboard";
  if (loadingUser) return <div>Loading...</div>;

 const scrollbarStyles = `
  .nav-container::-webkit-scrollbar {
    height: 4px;
  }
  .nav-container::-webkit-scrollbar-track {
    background: transparent;
  }
  .nav-container::-webkit-scrollbar-thumb {
    background: ${PRIMARY}30;
    borderRadius: 2px;
  }
  .nav-container::-webkit-scrollbar-thumb:hover {
    background: ${PRIMARY}50;
  }
  .menu-item:hover {
    background: ${PRIMARY} !important;
    color: ${SECONDARY} !important;
  }
  .menu-item:hover > span:first-child {
    background: ${SECONDARY} !important;
  }
`;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        marginTop: "-8px",
        marginLeft: "-20px",
        marginRight: "-8px",
        fontFamily: "Inter,system-ui,sans-serif",
        background: SECONDARY,
      }}
    >
      <style>{scrollbarStyles}</style>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 24px",
          background: PRIMARY,
          height: 54,
          color: SECONDARY,
          fontWeight: 700,
        }}
      >
        <h2 style={{ margin: 0, fontSize: "20px" }}>📦 Billing Software</h2>
        <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
          <div style={{ position: "relative", padding: 5 }}>
            <Bell size={18} />
            <span
              style={{
                position: "absolute",
                top: 2,
                right: 2,
                width: 8,
                height: 8,
                background: SECONDARY,
                borderRadius: "50%",
                border: `1px solid ${PRIMARY}`,
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              padding: "7px 13px",
              borderRadius: 14,
              position: "relative",
              background: showAdminMenu ? SECONDARY : PRIMARY,
              color: showAdminMenu ? PRIMARY : SECONDARY,
              border: showAdminMenu ? `1.3px solid ${PRIMARY}` : "none",
              fontWeight: 600,
              fontSize: 15,
              transition: "all 0.2s ease",
            }}
            onMouseEnter={() => setShowAdminMenu(true)}
            onMouseLeave={() => setShowAdminMenu(false)}
          >
            <Settings size={15} style={{ marginRight: 7 }} />
            <span style={{ marginRight: 7 }}>{branchName}</span>
            <ChevronDown size={13} />
            {showAdminMenu && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  right: 0,
                  background: SECONDARY,
                  color: PRIMARY,
                  borderRadius: 6,
                  boxShadow: `0 4px 14px ${PRIMARY}28`,
                  border: `1.2px solid ${PRIMARY}14`,
                  width: 155,
                  zIndex: 999,
                  marginTop: 3,
                }}
              >
                <Link to="/dashboard/branch-profile" style={{ color: PRIMARY, textDecoration: "none" }}>
                  <div
                    style={{
                      padding: "11px 19px",
                      borderRadius: "4px",
                      fontWeight: location.pathname === "/dashboard/branch-profile" ? 700 : 500,
                      background: location.pathname === "/dashboard/branch-profile" ? PRIMARY : SECONDARY,
                      color: location.pathname === "/dashboard/branch-profile" ? SECONDARY : PRIMARY,
                      transition: "all 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      if (location.pathname !== "/dashboard/branch-profile") {
                        e.currentTarget.style.background = PRIMARY;
                        e.currentTarget.style.color = SECONDARY;
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (location.pathname !== "/dashboard/branch-profile") {
                        e.currentTarget.style.background = SECONDARY;
                        e.currentTarget.style.color = PRIMARY;
                      }
                    }}
                  >
                    Branch Profile
                  </div>
                </Link>
              </div>
            )}
          </div>
          <button
    onClick={handleLogout}
    style={{
      display: "flex",
      alignItems: "center",
      gap: 6,
      background: SECONDARY,
      border: `2px solid ${PRIMARY}`, // Highlight with a border
      color: PRIMARY,
      cursor: "pointer",
      padding: "7px 13px",
      borderRadius: 10,
      fontWeight: 600,
      fontSize: 15,
      boxShadow: `0 1px 6px ${PRIMARY}14`,
      transition: "all 0.2s ease",
    }}
 
  >
    <LogOut size={13} />
    <span>Logout</span>
  </button>
        </div>
      </div>
      <div
        ref={menuBarRef}
        style={{
          background: SECONDARY,
          color: PRIMARY,
          borderBottom: `1.4px solid ${PRIMARY}18`,
          position: "relative",
        }}
      >
        <div
          className="nav-container"
          style={{
            display: "flex",
            alignItems: "center",
            height: "47px",
            padding: "0 18px",
            scrollbarWidth: "thin",
            scrollbarColor: `${PRIMARY}30 transparent`,
            WebkitOverflowScrolling: "touch",
          }}
        >
          <Link to="/dashboard" style={{ textDecoration: "none", color: "inherit", flexShrink: 0 }}>
         <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "0 11px",
                height: "100%",
                cursor: "pointer",
                borderBottom: isDashboardHome ? `3px solid ${PRIMARY}` : "transparent",
                background: isDashboardHome ? `${PRIMARY}09` : "transparent",
                borderRadius: "0 0 5px 5px",
                fontWeight: 600,
                color: PRIMARY,
                whiteSpace: "nowrap",
                transition: "all 0.2s ease",
              }}
              onClick={() => setOpenMenus([])}
              onMouseEnter={(e) => {
                if (!isDashboardHome) {
                  e.currentTarget.style.background = `${PRIMARY}09`;
                }
              }}
              onMouseLeave={(e) => {
                if (!isDashboardHome) {
                  e.currentTarget.style.background = "transparent";
                }
              }}
            >
              <Home size={15} />
              <span style={{ marginLeft: 7 }}>
                DASHBOARD
              </span>
            </div>
          </Link>
          {filteredMenuData.map((tab) => {
            const isTabActive = activeMenu === tab.label || openMenus[0] === tab.label;
            return (
              <div
                key={tab.key}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "0 11px",
                  height: "100%",
                  cursor: "pointer",
                  borderBottom: isTabActive ? `3px solid ${PRIMARY}` : "transparent",
                  background: isTabActive ? `${PRIMARY}09` : "transparent",
                  borderRadius: "0 0 5px 5px",
                  fontWeight: 600,
                  color: PRIMARY,
                  position: "relative",
                  flexShrink: 0,
                  whiteSpace: "nowrap",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  forceMenuOpen([tab.label]);
                  if (!isTabActive) {
                    e.currentTarget.style.background = `${PRIMARY}09`;
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isTabActive) {
                    e.currentTarget.style.background = "transparent";
                  }
                }}
              >
                {tab.icon}
                <span style={{ marginLeft: 7, fontSize: "14px" }}>{tab.label}</span>
                <ChevronDown size={12} style={{ marginLeft: 4 }} />
                {openMenus[0] === tab.label && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      color: PRIMARY,
                      width: "180px",
                      boxShadow: `0 6px 24px 0 ${PRIMARY}12`,
                      borderRadius: "0 8px 8px 8px",
                      zIndex: 700,
                      border: `1.2px solid ${PRIMARY}10`,
                      padding: "6px 0",
                      background: SECONDARY,
                      maxHeight: "70vh",
                      
                    }}
                  >
                    {renderMenuItems(tab.submenu, [tab.label])}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      <div
        style={{
          flex: 1,
          padding: 22,
          background: CONTENT_BG,
        }}
      >
        <div
          style={{
            padding: "24px",
            minHeight: "87%",
            borderRadius: 10,
          }}
        >
          {isDashboardHome ? (
            <div>
              <MainLayout />
            </div>
          ) : (
            <Outlet />
          )}
        </div>
      </div>
    </div>
  );
}